import { defineStore } from 'pinia'

export const useMainStore = defineStore('main', {
  state: () => ({
    isDarkMode: window.localStorage.isDarkMode !== undefined ? Boolean(parseInt(window.localStorage.isDarkMode)) : true,
    nodeSideMenuWidth: window.localStorage.nodeSideMenuWidth !== undefined ? parseInt(window.localStorage.nodeSideMenuWidth) : -1,

    sidemenuToggle: null,

    layout: 'div',
    activeMenu: '',
    podRightMenu: '',
    snackbars: [],
    subscriptionContactDialogVisible: false,

    // Track which persistent snackbars should be displayed across page navigations
    persistentSnackbars: [],
  }),
  getters: {
    getDarkMode(state) {
      return state.isDarkMode;
    },
    getSidemenuToggle(state) {
      return state.sidemenuToggle;
    },

    getActiveMenu: function(state) {
      return state.activeMenu;
    },

    getPodRightMenu: function(state) {
      return state.podRightMenu;
    },

    getSnackbars: function(state) {
      // Combine regular and persistent snackbars
      return [...state.snackbars, ...state.persistentSnackbars];
    },
  },
  actions: {
    setDarkMode(mode) {
      const isDarkMode = Boolean(mode);
      this.isDarkMode = isDarkMode;
      window.localStorage.isDarkMode = isDarkMode ? 1 : 0;
    },
    toggleSidemenu() {
      this.sidemenuToggle = !this.sidemenuToggle;
    },
    setLayout: function(layoutName) {
      if (this.layout !== layoutName) {
        this.layout = layoutName;
      }
    },

    setActiveMenu: function(menuName) {
      this.activeMenu = menuName;
    },

    setPodRightMenu: function(menuName) {
      this.podRightMenu = menuName;
    },
    showSubscriptionContactDialog() {
      this.subscriptionContactDialogVisible = true;
    },
    hideSubscriptionContactDialog() {
      this.subscriptionContactDialogVisible = false;
    },


    createSnackbar(snack) {
      // Create a deep copy of the snack object
      const snackbarCopy = JSON.parse(JSON.stringify(snack));

      // Set id and ensure timeout exists
      snackbarCopy.id = new Date().getTime();

      // Only set default timeout if not explicitly provided
      if (snackbarCopy.timeout === undefined) {
        snackbarCopy.timeout = 3000;
      }

      // Check for duplicates
      /*
      const isDuplicate = (item) => {
        if (snackbarCopy?.i18n && item?.i18n === snackbarCopy.i18n) return true;
        if (snackbarCopy?.replaceTCode && item?.replaceTCode === snackbarCopy.replaceTCode) return true;
        return false;
      };
      */

      this.snackbars = [];
      this.persistentSnackbars = [];

      // Handle permanent vs temporary snackbars differently
      if (snackbarCopy.timeout === -1) {
        // For permanent snackbars
        // if (!this.persistentSnackbars.some(isDuplicate)) {
        //   this.persistentSnackbars.push(snackbarCopy);
        // }

        this.persistentSnackbars.push(snackbarCopy);
      } else {
        // For temporary snackbars
        // if (!this.snackbars.some(isDuplicate)) {
        //   this.snackbars.push(snackbarCopy);
        // }

        this.snackbars.push(snackbarCopy);
      }
    },

    upsertSnackbar(snack, matcher) {
      const snackbarCopy = JSON.parse(JSON.stringify(snack));

      if (snackbarCopy.timeout === undefined) {
        snackbarCopy.timeout = 3000;
      }

      const collections = [ 'snackbars', 'persistentSnackbars' ];
      for (const collectionName of collections) {
        const currentItems = this[collectionName];
        const existingIndex = currentItems.findIndex(matcher);

        if (existingIndex === -1) {
          continue;
        }

        snackbarCopy.id = currentItems[existingIndex].id;
        this[collectionName] = [
          ...currentItems.slice(0, existingIndex),
          snackbarCopy,
          ...currentItems.slice(existingIndex + 1),
        ];
        return;
      }

      this.createSnackbar(snackbarCopy);
    },

    removeSnackbar: function(snackbarData) {
      // Remove from regular snackbars
      this.snackbars = this.snackbars.filter(x => x.id !== snackbarData.id);

      // Also remove from persistent snackbars
      this.persistentSnackbars = this.persistentSnackbars.filter(x => x.id !== snackbarData.id);
    },

    resetSnackbar: function() {
      // On page navigation, clear all temporary snackbars
      // but keep persistent snackbars
      this.snackbars = [];
    },
    setNodeSideMenuWidth: function(width) {
      this.nodeSideMenuWidth = width;
      window.localStorage.nodeSideMenuWidth = width;
    },
  },
});
